import { Dispatch } from "react";
import { Types } from "./TrainingContext";

export const openKardexModal = (
  _id = "",
  openModalKardex = true,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.OPEN_KARDEX,
    payload: {
      _id,
      openModalKardex,
    },
  });
};

export const closeKardex = (
  { _id = "", openModalKardex = false }: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CLOSE_KARDEX,
    payload: {
      _id,
      openModalKardex,
    },
  });
};

export const openModalConfirmFinishCourse = (
  _id = "",
  _idCTP = "",
  _bussinesName = "",
  openConfirmFinishCourse = true,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.OPEN_CONFIRM_FINISH_COURSE,
    payload: {
      _id,
      _idCTP,
      _bussinesName,
      openConfirmFinishCourse,
    },
  });
};
export const closeModalConfirmFinishCourse = (
  {
    _id = "",
    _idCTP = "",
    _bussinesName = "",
    openConfirmFinishCourse = false,
  }: any,
  dispatch: Dispatch<any>
): void => {
  dispatch({
    type: Types.CLOSE_CONFIRM_FINISH_COURSE,
    payload: {
      _id,
      _idCTP,
      _bussinesName,
      openConfirmFinishCourse,
    },
  });
};
